import React, {Fragment} from 'react';
import {Popup, Dropdown, Form, Edit, Submit} from 'components';
import {get, api, capitalize, useNamedSelector} from 'helpers';
import {store} from 'store';
import {set} from 'store/settings';

export function General() {
  const { user } = useNamedSelector('session.session');
  const { firstDayOfWeek, theme } = useNamedSelector('settings.settings');
  return (
    <Fragment>
      <div className="medium-spacing">
        <Form initialValues={{ email: user.email, currentEmail: user.email }} onSubmit={updateEmail}>
          <b>Email</b>
          <Edit className="small-spacing" name="email" type="email" required />
          <p className="text-right">
            <Submit>
              {[ 'Update', 'Updating..', 'Saved' ]}
            </Submit>
          </p>
        </Form>
        <hr />
        <Form initialValues={{ firstDayOfWeek, theme }} onChange={updateSettings}>
          <Dropdown label="First day of the week" name="firstDayOfWeek" Popup={FirstDayOfWeek}>
            { value => <b>{ get(['Sunday', 'Monday'], value - 1) }</b> }
          </Dropdown>
          <br />
          <Dropdown label="Theme" name="theme" Popup={Themes}>
            { value => <b>{ capitalize(value) }</b> }
          </Dropdown>
        </Form>
      </div>
    </Fragment>
  );
}

function FirstDayOfWeek({ value, setValue }) {
  return (
    <Popup.Menu>
      <Popup.Menu.Item pressed={value == 1} onClick={() => setValue(1)}>Sunday</Popup.Menu.Item>
      <Popup.Menu.Item pressed={value == 2} onClick={() => setValue(2)}>Monday</Popup.Menu.Item>
    </Popup.Menu>
  );
}

function Themes({ value, setValue }) {
  return (
    <Popup.Menu>
      <Popup.Menu.Item pressed={value == 'light'} onClick={() => setValue('light')}>Light</Popup.Menu.Item>
      <Popup.Menu.Item pressed={value == 'dark'} onClick={() => setValue('dark')}>Dark</Popup.Menu.Item>
    </Popup.Menu>
  );
}

function updateSettings(_, values) {
  for (const key in values) {
    set({ key, value: values[key] });
  }
}

async function updateEmail({ currentEmail, email }) {
  if (currentEmail != email) {
    try {
      await api('/set-settings/', { data: { email } });
      store.dispatch({
        type: 'EMAIL_CHANGED',
        email,
        notification: 'Your email has been changed!',
      });
    } catch ({ error }) {
      const errors = {
        'Failed to fetch': 'The server is not responding. Please try again later.',
        'Wrong password': 'The old password you entered is incorrect. Please try again.',
        'Email address is already in use': 'This email is already in use. Please pick another one.',
      }
      store.dispatch({
        type: 'UI_ERROR',
        errorMessage: errors[error] || 'Error. Please try again.',
        error,
      });
    }
  }
}
